import React from 'react'
import { AlertTriangleIcon } from 'lucide-react'
import LazyLoad from 'react-lazyload'

import { ErrorBoundary } from '@/shared/components/ErrorBoundary'
import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
} from '@/shared/components/ui/empty'
import { Skeleton } from '@/shared/components/ui/skeleton'
import { cn } from '@/shared/lib/utils'

export function WidgetWrapper({
	children,
	className,
}: {
	className?: string
	children: React.ReactNode
}) {
	return (
		<ErrorBoundary
			fallback={
				<WidgetError
					className={cn('flex h-full min-h-36 flex-col', className)}
				/>
			}
		>
			<LazyLoad
				once
				scrollContainer='#dashboard-scrollable-area'
				className={cn('flex h-full min-h-36 flex-col', className)}
				placeholder={<Skeleton className='flex size-full flex-col' />}
			>
				{children}
			</LazyLoad>
		</ErrorBoundary>
	)
}

const WidgetError = ({ className }: { className?: string }) => (
	<div
		className={cn(
			'flex h-full flex-col items-center justify-center rounded-lg border border-dashed border-destructive/50 bg-destructive/10',
			className
		)}
	>
		<Empty className='md:p-4'>
			<EmptyHeader>
				<EmptyMedia
					variant='icon'
					className='bg-destructive/20 text-destructive'
				>
					<AlertTriangleIcon />
				</EmptyMedia>
				<EmptyDescription className='text-destructive'>
					Something went wrong
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	</div>
)
